export { SiteFooter as Footer } from "@/components/mot/chrome";
